import { render, staticRenderFns } from "./apple_tab_bar.vue?vue&type=template&id=5fbd1a2c&scoped=true"
import script from "./apple_tab_bar.vue?vue&type=script&lang=js"
export * from "./apple_tab_bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbd1a2c",
  null
  
)

export default component.exports